<gbc-breadcrumb [pageInfo]="pageInfo"></gbc-breadcrumb>
@if (pageInfo) {
  <div class="header-container">
    <div class="header">
      @if (pageInfo.parent) {
        <div class="header-button-container left">
          <a class="header-button" [routerLink]="backRoute ? backRoute : pageInfo.parent.link"><img src="./assets/svgs/back.svg" alt="Back" data-test-id="back-button"></a>
        </div>
      }
      <div class="header-headline-container">
        <h2 class="header-headline">
          {{pageInfo.title | async}}
          @if (menuItems && menuItems.length) {
            <button class="header-action-menu-button" [gbcMenuTriggerFor]="headerActionsMenu"><gbc-icon iconName="menu-more" alt="More"></gbc-icon></button>
          }
          <gbc-menu #headerActionsMenu>
            <ng-content select="[gbc-page-header-actions]"></ng-content>
          </gbc-menu>
        </h2>
        @for (subtitle of pageInfo.subtitles; track subtitle) {
          @if (subtitle) {
            <p class="header-subheader">{{subtitle | async}}</p>
          }
          <ng-content select="[gbc-page-header-left]"></ng-content>
        }
      </div>
      <div class="header-button-container right">
        <div>
          <ng-content select="[gbc-page-header-right]"></ng-content>
        </div>
      </div>
    </div>
  </div>
}
